// Coordinates for the main location to show on maps
export const LATITUDE = 59.313037

export const LONGITUDE = 18.101267

export const POSITION = [LATITUDE, LONGITUDE]

//export const GOOGLE_MAPS_API_KEY = 'AIzaSyBP4OiGgrmYEv19k0BlP1eVRBqsnfliSwI'
export const GOOGLE_MAPS_API_KEY = 'AIzaSyB7Zo0065Cn1r97x5X42BPwq6gmYEZ5kxk'

export const VITEC_GQL = 'https://newapi.detvitahuset.se/newgraphql'
// export const VITEC_GQL = 'https://api.novire.se/graphql'

export const PROPERTY_GUID = '4H0A239TSE251AIS'

export const SITE_URL = 'https://www.detvitahuset.se'